import { useEffect, useState } from "react";
import "../../Styles/stats.scss";
import BarGraphExpense from "../Stats/BarGraphExpense";
import BubbleChartMonth from "../Stats/BubbleChartMonths";
import CustomPieChart from "../Stats/CustomPieChart";
import CustomBarChart from "../Stats/CustomBarChart";
import StackedAreaChart from "../Stats/StackedAreaChart";
import HorizontalChart from "../Stats/HorizontalChart";
import { useLayoutEffect } from "react";
import { useRef } from "react";
import html2canvas from "html2canvas";
import { BsImages, BsFiletypeCsv } from "react-icons/bs";

export default function VCStats(props) {
  const [data, setData] = useState(null);
  const [charts, setCharts] = useState(null);
  const [stats, setStats] = useState(null);
  const chrt = useRef(null);
  const [showing, setShowing] = useState(true);
  const [aspect, setAspect] = useState(1.5);
  const [aspect1, setAspect1] = useState(1.5);

  const p1ref = useRef();
  const p2ref = useRef();
  const p3ref = useRef();

  const b1ref = useRef();
  const b2ref = useRef();

  const h1ref = useRef();
  const h2ref = useRef();

  useLayoutEffect(() => {
    const { width, height } = p1ref.current.getBoundingClientRect();

    setAspect(width / height);
    setAspect1(width / (height * 0.8));
  }, []);

  const handleDownloadImage = async (printRef) => {
    const element = printRef.current;
    const canvas = await html2canvas(element);

    const data = canvas.toDataURL("image/jpg");
    const link = document.createElement("a");

    if (typeof link.download === "string") {
      link.href = data;
      link.download = "image.jpg";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open(data);
    }
  };

  const saveData = (data) => {
    if (data.length > 0) {
      let rows = [];
      rows.push(Object.keys(data[0]));
      data.map((item) => {
        rows.push(Object.values(item));
      });
      let csvContent =
        "data:text/csv;charset=utf-8," +
        rows.map((e) => e.join(",")).join("\n");

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "data.csv");
      document.body.appendChild(link);
      link.click();
    }
  };

  useEffect(() => {
    setShowing(false);
    setTimeout(() => {
      setShowing(true);
    }, 1);
  }, [props.showing]);

  useEffect(() => {
    fetch(`/api/farmeraddress/topvcstats/${props.title}`)
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error("");
      })
      .then((data) => {
        setStats(data);
      })
      .catch((e) => {});
  }, []);

  useEffect(() => {
    fetch(`/api/farmeraddress/completevccharts/${props.title}`)
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error("");
      })
      .then((data) => {
        setCharts(data);
      })
      .catch((e) => {});
  }, []);

  return (
    <>
      {showing && (
        <div className="stats">
          <div className="top">
            <TopItem
              title="Mapped Farmers"
              amt={stats ? stats.allfarmers : 0}
              color="#C9EEFF"
            />
            <TopItem
              title={`${props.title} Farmers`}
              amt={stats ? stats.vcfarmers : 0}
              color="#F1DEC9"
            />
            <TopItem
              title="Total Acreage"
              amt={stats ? stats.mappedacreage : 0}
              color="#FBFFB1"
            />
            <TopItem
              title={`${props.title} Acreage`}
              amt={stats ? stats.vcacreage : 0}
              color="#FFA3FD"
            />
            <TopItem
              title={`${props.title} Production`}
              amt={stats ? stats?.vcproduction : 0}
              color="#C9F4AA"
            />
            <TopItem
              title="Wards Practiced"
              amt={stats ? stats?.vcwards : 0}
              color="#FFFBEB"
            />
          </div>
          <div className="pies">
            <div ref={p1ref} className="chart">
              <h3>Gender Distribution</h3>
              {charts && (
                <CustomPieChart data={charts?.gender} aspect={aspect} />
              )}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(p1ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(charts?.gender);
                  }}
                />
              </div>
            </div>
            <div ref={p2ref} className="chart">
              <h3>Age Distribution</h3>
              {charts && (
                <CustomPieChart data={charts?.agegroup} aspect={aspect} />
              )}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(p2ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(charts?.agegroup);
                  }}
                />
              </div>
            </div>
            <div ref={p3ref} className="chart">
              <h3>Sub-County Distribution</h3>
              {charts && (
                <CustomPieChart data={charts?.subcounty} aspect={aspect} />
              )}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(p3ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(charts?.subcounty);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="middle">
            <div ref={b1ref} className="chart">
              <h3>Ward Distribution</h3>
              {charts && (
                <CustomBarChart data={charts?.ward} aspect={aspect1} />
              )}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(b1ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(charts?.ward);
                  }}
                />
              </div>
            </div>
            <div ref={b2ref} className="chart">
              <h3>Group Distribution</h3>
              {charts && (
                <CustomBarChart data={charts?.group} aspect={aspect1} />
              )}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(b2ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(charts?.Ward);
                  }}
                />
              </div>
            </div>
          </div>
          {/* <div className="bottom">
            <div ref={h1ref} className="chart">
              <h3>Farmer Groups</h3>
              {charts && (
                <HorizontalChart
                  data={charts?.Classification}
                  aspect={aspect1}
                />
              )}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(h1ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(charts?.Classification);
                  }}
                />
              </div>
            </div>
            <div ref={h2ref} className="chart">
              <h3>Value Chains</h3>
              {charts && (
                <HorizontalChart data={charts?.Department} aspect={aspect1} />
              )}
              <div className="save">
                <BsImages
                  color="blue"
                  onClick={() => {
                    handleDownloadImage(h2ref);
                  }}
                />
                <BsFiletypeCsv
                  color="blue"
                  onClick={() => {
                    saveData(charts?.Department);
                  }}
                />
              </div>
            </div>
          </div> */}
        </div>
      )}
    </>
  );
}

const TopItem = (props) => {
  function withCommas(x) {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return (
    <div
      style={{ backgroundColor: props.color ?? props.color }}
      className="tp_item"
    >
      <p>{props.title}</p>
      <h1>{withCommas(props.amt)}</h1>
    </div>
  );
};
